shadow$provide[523] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, parse:{enumerable:true, get:function() {
  return parse;
}}, walk:{enumerable:true, get:function() {
  return walk;
}}});
var require$glsl_tokenizer_SLASH_string = require("glsl-tokenizer/string");
var require$_CIRCA_sicmutils_SLASH_glsl_parser_SLASH_direct = require("@sicmutils/glsl-parser/direct");
var require$_DOT__SLASH_decl = require("./decl");
var require$_DOT__SLASH_constants = require("./constants");
var default$$require$_CIRCA_sicmutils_SLASH_glsl_parser_SLASH_direct = require.esmDefault(require$_CIRCA_sicmutils_SLASH_glsl_parser_SLASH_direct);
var default$$require$glsl_tokenizer_SLASH_string = require.esmDefault(require$glsl_tokenizer_SLASH_string);
let debug = false;
const parse = function(name, code) {
  const ast = parseGLSL(name, code);
  return processAST(ast, code);
};
const parseGLSL = function(name, code) {
  let ast, tock;
  let errors = [];
  if (debug) {
    tock = tick();
  }
  try {
    const tokens = (0,default$$require$glsl_tokenizer_SLASH_string.default)(code);
    ast = (0,default$$require$_CIRCA_sicmutils_SLASH_glsl_parser_SLASH_direct.default)(tokens);
  } catch (e) {
    errors = [{message:e}];
  }
  if (debug) {
    tock("GLSL Tokenize \x26 Parse");
  }
  const fmt = function(code) {
    code = code.split("\n");
    const max = ("" + code.length).length;
    const pad = function(v) {
      if ((v = "" + v).length < max) {
        return ("       " + v).slice(-max);
      } else {
        return v;
      }
    };
    return code.map((line, i) => `${pad(i + 1)}: ${line}`).join("\n");
  };
  if (!ast || errors.length) {
    if (!name) {
      name = "(inline code)";
    }
    console.warn(fmt(code));
    for (const error of errors) {
      console.error(`${name} -`, error.message);
    }
    throw new Error("GLSL parse error");
  }
  return ast;
};
const processAST = function(ast, code) {
  let tock;
  if (debug) {
    tock = tick();
  }
  const symbols = [];
  walk(mapSymbols, collect(symbols), ast, "");
  const [main, internals, externals] = Array.from(sortSymbols(symbols));
  const signatures = extractSignatures(main, internals, externals);
  if (debug) {
    tock("GLSL AST");
  }
  return {ast, code, signatures};
};
const mapSymbols = function(node, collect) {
  switch(node.type) {
    case "decl":
      collect(require$_DOT__SLASH_decl.decl.node(node));
      return false;
  }
  return true;
};
const collect = out => function(value) {
  if (value != null) {
    Array.from(value).map(obj => out.push(obj));
  }
};
const sortSymbols = function(symbols) {
  let main = null;
  const internals = [];
  let externals = [];
  const maybe = {};
  let found = false;
  for (const s of Array.from(symbols)) {
    if (!s.body) {
      if (s.storage === "global") {
        internals.push(s);
      } else {
        externals.push(s);
        maybe[s.ident] = true;
      }
    } else {
      if (maybe[s.ident]) {
        externals = Array.from(externals).filter(e => e.ident !== s.ident);
        delete maybe[s.ident];
      }
      internals.push(s);
      if (s.ident === "main") {
        main = s;
        found = true;
      } else if (!found) {
        main = s;
      }
    }
  }
  return [main, internals, externals];
};
const extractSignatures = function(main, internals, externals) {
  let symbol;
  const sigs = {uniform:[], attribute:[], varying:[], external:[], internal:[], global:[], main:null,};
  const defn = symbol => require$_DOT__SLASH_decl.decl.type(symbol.ident, symbol.type, symbol.quant, symbol.count, symbol.inout, symbol.storage);
  const func = function(symbol, inout) {
    let d;
    const signature = Array.from(symbol.args).map(arg => defn(arg));
    for (d of Array.from(signature)) {
      if (d.inout === require$_DOT__SLASH_decl.decl.inout) {
        const a = d;
        const b = d.copy();
        a.inout = require$_DOT__SLASH_decl.decl.in;
        b.inout = require$_DOT__SLASH_decl.decl.out;
        b.meta = {shadow:a.name};
        b.name += require$_DOT__SLASH_constants.SHADOW_ARG;
        a.meta = {shadowed:b.name};
        signature.push(b);
      }
    }
    if (symbol.type !== "void") {
      signature.unshift(require$_DOT__SLASH_decl.decl.type(require$_DOT__SLASH_constants.RETURN_ARG, symbol.type, false, "", "out"));
    }
    const inTypes = (() => {
      const result = [];
      for (d of Array.from(signature)) {
        if (d.inout === require$_DOT__SLASH_decl.decl.in) {
          result.push(d.type);
        }
      }
      return result;
    })().join(",");
    const outTypes = (() => {
      const result1 = [];
      for (d of Array.from(signature)) {
        if (d.inout === require$_DOT__SLASH_decl.decl.out) {
          result1.push(d.type);
        }
      }
      return result1;
    })().join(",");
    const type = `(${inTypes})(${outTypes})`;
    return {name:symbol.ident, type, signature, inout, spec:symbol.type,};
  };
  sigs.main = func(main, require$_DOT__SLASH_decl.decl.out);
  for (symbol of Array.from(internals)) {
    sigs.internal.push({name:symbol.ident,});
  }
  for (symbol of Array.from(externals)) {
    let def;
    switch(symbol.decl) {
      case "external":
        def = defn(symbol);
        sigs[symbol.storage].push(def);
        break;
      case "function":
        def = func(symbol, require$_DOT__SLASH_decl.decl.in);
        sigs.external.push(def);
        break;
    }
  }
  return sigs;
};
debug = false;
const walk = function(map, collect, node, indent) {
  debug && console.log(indent, node.type, node.token != null ? node.token.data : undefined, node.token != null ? node.token.type : undefined);
  const recurse = map(node, collect);
  if (recurse) {
    for (let i = 0; i < node.children.length; i++) {
      const child = node.children[i];
      walk(map, collect, child, indent + "  ", debug);
    }
  }
  return null;
};
const tick = function() {
  const now = +new Date();
  return function(label) {
    const delta = +new Date() - now;
    console.log(label, delta + " ms");
    return delta;
  };
};

};